import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=5c50fb26&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c50fb26', component.options)
    } else {
      api.reload('5c50fb26', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=5c50fb26&", function () {
      api.rerender('5c50fb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/confirm.vue"
export default component.exports